import React, { useEffect, useState } from 'react'

function useDimensions(targetRef) {
  const getDimensions = () => {
    return {
      width: targetRef.current ? targetRef.current.offsetWidth : 0,
      height: targetRef.current ? targetRef.current.offsetHeight : 0,
    }
  }

  const [dimensions, setDimensions] = useState(getDimensions)

  const handleResize = () => {
    setDimensions(getDimensions())
  }

  useEffect(() => {
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  useEffect(() => {
    handleResize()
  }, [])
  return dimensions
}

export default useDimensions
